<template>
  <div class="more-container">
    <w-popup-show :state="moreState" @handleClose="handleClose">
      <div slot="content" class="content" @touchmove.prevent>
        <div v-for="(item, index) in operationAry" :key="index" class="operation-item" @click="handleClick(item)"
             :class="[{'border-none': item.value === 'privacy'}, {'border-gray': item.value === 'delete'}]">
          <div class="operation-link flex-start">
            <span class="iconfont" :class="item.icon"/>
            <span>{{ item.label }}</span>
          </div>
        </div>
        <div class="cancel flex-center" @click="handleClose">取消</div>
      </div>
    </w-popup-show>
    <w-loading v-show="loadingShow" :show-text="true"/>
    <!--    <change-status :state="changeStatusShow" :cv-info="cvInfo" @deleteCv="_deleteCv"-->
    <!--                   @handleClose="changeStatusShow = false"/>-->
    <!-- <member-dialog :state="memberShow" @handleClose="memberShow = false"/> -->
    <w-popup :state="memberShow" @handleClose="memberShow = false">
      <operation-vip slot="content"  />
    </w-popup>

  </div>
</template>

<script>
    import WPopup from '@/components/global/w-popup'
    import operationVip from '../../views/cv-components/operation-vip.vue';
	import WPopupShow from '@/components/global/w-popup-show'
	import changeStatus from '../cv-components/change-cv-status'
	import memberDialog from '@/components/user/member-dialog'
	import WLoading from '@/components/global/w-loading'
	import { mapActions, mapState } from 'vuex'
	import { envMixin } from '@/assets/js/mixin/global'
	import { componentsMixin } from '@/assets/js/mixin/components'
	import { cvOperationMixin } from '../../assets/js/mixin/cv'
	import { userMixin } from '../../assets/js/mixin/user'

	export default {
		name: 'cv-more',
		mixins: [ envMixin, componentsMixin, cvOperationMixin, userMixin ],
		props: {
			moreState: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {
				cvInfo: {},
				changeStatusShow: false,
				memberShow: false,
				loadingShow: false,
				awaitLoadingShow: false
			}
		},
		mounted () {
		},
		computed: {
			...mapState('cv', [ 'cv', 'applies' ]),
			operationAry () {
				if (this.cv.basic_info && this.cv.basic_info.trans_cv_id) {
					return [
						{ label: '修改简历名称', value: 'editName', icon: 'iconxiugaijianlimingcheng' },
						{ label: '复制简历', value: 'copy', icon: 'iconfuzhijianli' },
						{ label: '删除简历', value: 'delete', icon: 'iconshanchujianli' },
					]
				} else {
					return [
						{ label: '修改简历名称', value: 'editName', icon: 'iconxiugaijianlimingcheng' },
						{ label: '翻译简历', value: 'translate', icon: 'iconfanyijianli' },
						{ label: '复制简历', value: 'copy', icon: 'iconfuzhijianli' },
						{ label: '删除简历', value: 'delete', icon: 'iconshanchujianli' },
					]
				}
			}
		},
		watch: {},
		components: {
			WPopupShow,
			changeStatus,
			memberDialog,
			WLoading,
			WPopup,
			operationVip,
		},
		methods: {
			...mapActions('cv', [ 'dealSignatrue', 'getCvApplies' ]),
			handleClose () {
				this.$emit('handleClose')
			},
			async handleClick (item) {
				let token = this.$route.params.token
				switch (item.value) {
					case 'editName':
						this.$emit('changeCv', 'cvName')
						this.handleClose()
						break
					case 'translate':
						this.handleClose()
						this.loadingShow = true
						let res = await this.$api.cv.verifyCanTransCv(this.cvAccountToken, { lang: this.cv.basic_info.lang === 'cn' ? 'en' : 'cn' })
						if (res.code === 1000) {
							if (await this.verifyCvCreate(this.cv.basic_info.lang === 'cn' ? 'en' : 'cn')) {
								this.loadingShow = false
                this.state = false
								return
              } else {
								let translateRes = await this.$api.cv.translateCv({ cv_token: token })
								if (translateRes.code === 1000) {
									this.handleClose()
									this.$fn.redirect(
										`${window.location.origin}/cvs/${ translateRes.data.basic_info.token }/editor`, 
										() => {
											this.$router.replace(`/cvs/${ translateRes.data.basic_info.token }/editor`)
										}
									)
									window.scrollTo(0, 0)
									this.loadingShow = false
								} else if (translateRes.code === 600213) {
									this.$fn.jump(
										`/pages/member-buy/index`,
										() => {
											this.$router.push(`/buy/member/order`)
										}
									)
								}
							  // else if ((translateRes.code === 3000 || translateRes.code === 3001)) {
								// 	this.loadingShow = false
								// 	this.showToast(translateRes.message, 2000)
								// 	setTimeout(() => {
								// 		this.state = false
								// 		if (!this.userData.is_membership) this.show = true
								// 	}, 1000)
								// }
              }
						} else if (res.code !== 2000) {
							this.showToast(res.message, 1500)
              if (res.code === 600213) {
	              setTimeout(() => {
		              // this.memberShow = true
									this.$fn.jump(
										`/pages/member-buy/index`,
										() => {
											this.$router.push(`/buy/member/order`)
										}
									)
	              }, 1500)
              }
              this.loadingShow = false
						}
						break
					case 'copy':
						this.handleClose()
						this.duplicateCv({ 'cv_token': token }, 'editor', this.cv.basic_info.lang)
						break
					case 'privacy':
						this.$emit('changeCv', 'privacy')
						this.handleClose()
						break
					case 'delete':
						this.handleClose()
						this._deleteCv(token, 'editor')
						break
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';

  .more-container {
    .content {
      width: 100vw;
      padding-top: 6px;
      .operation-item {
        padding: 18px 0;
        color: $color-title;
        font-weight: 400;
        border-bottom: 1px solid #f4f4f4;
        .operation-link {
          padding-left: 26px;
          .iconfont {
            font-size: 18px;
            margin-right: 10px;
            font-weight: bold;
            color: $color-dark-gray;
          }
        }
      }
      .border-none {
        border-bottom: none;
      }
      .border-gray {
        border-top: 6px solid #f9f9f9;
        /*border-bottom: 8px solid #f9f9f9;*/
      }
      .cancel {
        height: 64px;
        color: $color-title;
        font-size: $font-size-medium-x;
      }
    }
  }
</style>
